import { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';

import { getErrorMessage } from '../../ReactQuery/errors';
import { icons, IconText } from '../generic/Icon';
import Loader from '../generic/Loader';

type ModalAreYouSureProps = {
  title: string;
  actionName: string;
  verificationString: string;
  show: boolean;
  onHide: Function;
  executeAction(...args): Promise<void>;
  reversible?: boolean;
};

type ModalAreYouSureState = {
  inputVerificationText: string;
  hasExecuteActionError: boolean;
  err: string;
  loading: boolean;
};

export default class ModalAreYouSure extends Component<ModalAreYouSureProps, ModalAreYouSureState> {
  constructor(props) {
    super(props);

    this.state = {
      inputVerificationText: '',
      loading: false,
      hasExecuteActionError: false,
      err: null,
    };
  }

  onVerifyChange = (e) => {
    this.setState({ inputVerificationText: e.target.value });
  };

  onSubmit = async (_) => {
    this.setState({ loading: true });

    await this.props.executeAction()
      .then(() => this.hideAndClear())
      .catch(err => {
        this.setState({ hasExecuteActionError: true });
        this.setState({ err: getErrorMessage(err) });
      });

    this.setState({ loading: false });
  };

  hideAndClear = () => {
    this.setState({ hasExecuteActionError: false, err: null, inputVerificationText: '', loading: false });
    this.props.onHide();
  };

  renderAreYouSureSection = () => {
    const canDelete = this.props.verificationString.toLowerCase() === this.state.inputVerificationText.toLowerCase();

    return (
      <div>
        {this.props.reversible ? <h2>ARE YOU SURE?</h2> :
        <h2 style={{ color: 'red' }}>ARE YOU SURE? THIS IS NOT REVERSIBLE</h2>}

        <h4>Verify that you know what you're doing by typing in exactly what is being affected ({this.props.verificationString})</h4>
        <div>
          <input type="text" onChange={this.onVerifyChange} />
        </div>
        <div>
          { canDelete ? null : <small style={{ color: 'red' }}>Entered text does not match</small>}
        </div>
      </div>
    );
  };

  renderLoading = () => {
    return <Loader />;
  };

  renderErrorMessage = () => {
    return (
      <div className="alert">
        error on deletion: {this.state.err}
      </div>
    );
  };

  render() {
    const canDelete = this.props.verificationString.toLowerCase() === this.state.inputVerificationText.toLowerCase();

    return (
      <Modal show={this.props.show} backdrop animation onHide={this.hideAndClear}>
        <Modal.Header closeButton>
          <Modal.Title>
            {this.props.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.state.loading ? this.renderLoading() : this.renderAreYouSureSection()}
          &nbsp;&nbsp;
          {this.state.hasExecuteActionError ? this.renderErrorMessage() : null}
          {this.props.children}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.hideAndClear}>Cancel</Button>
          <Button bsStyle="danger" disabled={!canDelete || this.state.loading} onClick={this.onSubmit}>
            <IconText
              icon={icons.save}
              text={`Execute ${this.props.actionName}`}
            />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
